import { API } from "../api";

const BASE = "/cooperatives/payments/online-pending";

export const onlinePendingAdminApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getStaffOnlinePendingPayments: builder.query({
      query: ({
        status = "pending",
        search = "",
        payment_provider = "",
        page = 1,
        limit = 20,
      }) => {
        const params = new URLSearchParams({
          guard: "staff",
          status: String(status),
          page: String(page),
          limit: String(limit),
        });
        if (search) params.append("search", search);
        if (payment_provider) params.append("payment_provider", payment_provider);
        return { url: `${BASE}?${params.toString()}` };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "online-pending-payments", id: "list" }],
    }),

    getStaffOnlinePendingPaymentDetail: builder.query({
      query: (id) => ({
        url: `${BASE}/${id}?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, id) => [
        { type: "online-pending-payments", id: String(id) },
      ],
    }),

    requeryStaffOnlinePendingPayment: builder.mutation({
      query: ({ id, transaction_id } = {}) => ({
        url: `${BASE}/${id}/requery?guard=staff`,
        method: "POST",
        body: transaction_id ? { transaction_id } : {},
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "online-pending-payments" },
        { type: "member-contributions-history" },
        { type: "member-contributions-summary" },
        { type: "member-loan-summary" },
        { type: "member-upcoming-repayment-list" },
        { type: "member-due-repayment-list" },
        { type: "member-overdue-repayment-list" },
        { type: "member-transaction-history" },
        "MemberAttendance",
        { type: "member-online-pending-payments" },
        "StaffDashboard",
      ],
    }),
  }),
});

export const {
  useGetStaffOnlinePendingPaymentsQuery,
  useGetStaffOnlinePendingPaymentDetailQuery,
  useRequeryStaffOnlinePendingPaymentMutation,
} = onlinePendingAdminApi;
